import { createActionConst } from '../../utils/action.utils';

const SUPPORT_NAMESPACE = 'SUPPORT';

export const SUBMIT_SUPPORT_REQUEST = createActionConst(SUPPORT_NAMESPACE, 'SUBMIT_SUPPORT_REQUEST');
